import { useParams } from "react-router";

import { useFetchOrganisationInsightsQuery } from "../services/api/insightsApi/insights";

interface IUseOrgInsightsOptions {
  groupId?: number;
  asOfDate?: string;
  tags?: string[];
  excludeTags?: string[];
  excludeGroupIds?: number[];
  /** User id, or INSIGHTS_UNASSIGNED. Invoice assignee wins over the contact's */
  assignedUserId?: string;
  /** Also fetch monthly figures for the last 12 months as `history`. Expensive - use a separate call so the main figures paint first */
  history?: boolean;
  /** Don't fetch at all (e.g. history while the chart is collapsed) */
  skip?: boolean;
}

/**
 * Live (uncached) organisation insights. Unlike the old cached metrics there is
 * no polling - every request computes fresh, so we only refetch when args change.
 */
export function useOrgInsights({
  groupId,
  asOfDate,
  tags,
  excludeTags,
  excludeGroupIds,
  assignedUserId,
  history,
  skip,
}: IUseOrgInsightsOptions = {}) {
  const { organisationId } = useParams<{ organisationId: string }>();

  return useFetchOrganisationInsightsQuery(
    {
      organisationId: organisationId as string,
      groupId: groupId || undefined,
      asOfDate,
      tags: tags?.length ? tags : undefined,
      excludeTags: excludeTags?.length ? excludeTags : undefined,
      excludeGroupIds: excludeGroupIds?.length ? excludeGroupIds : undefined,
      assignedUserId: assignedUserId || undefined,
      history: history || undefined,
    },
    {
      skip: !organisationId || skip,
      refetchOnMountOrArgChange: true,
    },
  );
}
